export const CountChip = ({ count }) => (
  <span className="ml-2 px-2 py-0.5 text-xs font-medium bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-full">
    {count}
  </span>
);
